import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Form, Checkbox, Row, Col } from 'antd';
import FormLabel from 'components/FormLabel/FormLabel';

import styled from 'styled-components/macro';

const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;

const addRules = requiredErrorMessage => {
  const rules = [];
  if (requiredErrorMessage && typeof requiredErrorMessage === 'string') {
    rules.push({
      required: true,
      message: requiredErrorMessage
    });
  }
  return rules;
};

const FormCheckbox = ({ className, defaultValue, form, formLabel, label, onChange, name, requiredErrorMessage, size, selections, shouldDisable, colSize }) => {
  const rules = addRules(requiredErrorMessage);
  return (
    <Fragment>
      {!formLabel && <FormLabel size={size} className={className}>{label || name}</FormLabel>}
      <FormItem label={formLabel} colon={false}>
        {form.getFieldDecorator(name, {
          rules: rules,
          initialValue: defaultValue
        })(<CheckboxGroup 
            onChange={onChange}
            size={size}
            disabled={shouldDisable}>
              <Row>
                {selections.map(selection => 
                <Col {...colSize} key={selection.value}>
                  <Checkbox value={selection.value}>{selection.label}</Checkbox>
                </Col>)}
              </Row>
            </CheckboxGroup>)}
      </FormItem>
    </Fragment>
  );
};

FormCheckbox.propTypes = {
  form: PropTypes.object.isRequired,
  formLabel: PropTypes.string,
  name: PropTypes.string.isRequired,
  selections: PropTypes.array.isRequired,
  defaultValue: PropTypes.any,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  capitalize: PropTypes.bool,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  requiredErrorMessage: PropTypes.string,
  shouldDisable: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'large']),
  colSize: PropTypes.object,
};

FormCheckbox.defaultProps = {
  form: {},
  label: '',
  placeholder: '',
  capitalize: true,
  shouldDisable: false,
  requiredErrorMessage: '',
  size: 'default',
  colSize: { span: 12, md: 8 },
};

export default styled(FormCheckbox)`
  margin-bottom: 0px;
  ${props => props.capitalize && `text-transform: capitalize` };
`;
